import classNames from 'classnames'
import { forwardRef, HTMLAttributes } from 'react'

import { Slot } from '../utilities'
import styles from './chat-message.module.scss'

export type ChatMessageHeaderElement = HTMLDivElement
export type ChatMessageHeaderProps = HTMLAttributes<ChatMessageHeaderElement> & {
  asChild?: boolean
}

export const ChatMessageHeader = forwardRef<ChatMessageHeaderElement, ChatMessageHeaderProps>(
  function ChatMessageHeader(props, forwardedRef) {
    const { className, asChild, ...rest } = props
    const classes = classNames(styles.header, className)
    const Component = asChild ? Slot : 'div'
    return <Component {...rest} className={classes} ref={forwardedRef} />
  }
)
